(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chinese-almanac"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('chinese-almanac')) return;
    const cache = new Map();
    const todayKey = () => {
      const p = Object.fromEntries(new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).map(x => [x.type, x.value]));
      return `${p.year}-${p.month}-${p.day}`;
    };
    const shiftDay = (key, days) => new Date(Date.parse(`${key}T04:00:00Z`) + days * 86400000).toISOString().slice(0, 10);
    const fill = (text, values) => text.replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');
    class ChineseAlmanac extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.token = 0;
        this.config = JSON.parse(this.querySelector('[data-calendar-config]').textContent);
        this.labels = this.config.labels;
        this.activities = this.labels.activities.join('|').split('|');
        this.terms = this.labels.terms.split('|');
        this.animals = this.labels.animals.split('|');
        this.stems = this.labels.stems.split('|');
        this.branches = this.labels.branches.split('|');
        this.body = this.querySelector('[data-calendar-body]');
        this.selected = todayKey();
        this.lastToday = this.selected;
        const years = Object.keys(this.config.years).sort();
        this.minimum = `${years[0]}-01-01`;
        this.maximum = `${years.at(-1)}-12-31`;
        const signal = this.controller.signal;
        this.querySelectorAll('[data-shift]').forEach(button => button.addEventListener('click', () => this.load(shiftDay(this.selected, Number(button.dataset.shift)), true), { signal }));
        this.querySelector('[data-today]').addEventListener('click', () => this.load(todayKey(), true), { signal });
        this.querySelector('[data-retry]').addEventListener('click', () => this.load(this.selected), { signal });
        this.details = this.querySelector('.cs-almanac__details');
        this.details?.addEventListener('toggle', () => this.syncDisclosure(), { signal });
        this.addEventListener('click', event => {
          const button = event.target.closest?.('[data-almanac-more]');
          if (!button || !this.contains(button) || !this.details) return;
          this.details.open = !this.details.open;
          this.syncDisclosure();
        }, { signal });
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.checkDay(); }, { signal });
        this.timer = window.setInterval(() => this.checkDay(), 60000);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.load(this.selected); } }, { rootMargin: '500px' });
          this.observer.observe(this);
        } else this.load(this.selected);
      }
      disconnectedCallback() {
        this.token++;
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        window.clearInterval(this.timer);
        this.transition?.skipTransition();
      }
      checkDay() {
        const now = todayKey();
        if (now !== this.lastToday) {
          const wasToday = this.selected === this.lastToday;
          this.lastToday = now;
          if (wasToday) this.load(now);
          else this.updateControls();
        }
      }
      dateFormat(key, options) {
        const language = this.dataset.language || 'en';
        return new Intl.DateTimeFormat(language, { timeZone: 'Asia/Shanghai', calendar: 'gregory', ...options }).format(new Date(`${key}T04:00:00Z`));
      }
      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = value;
      }
      cycle(index) {
        return `${this.stems[index % 10]} ${this.branches[index % 12]}`;
      }
      updateControls() {
        this.querySelector('[data-shift="-1"]').disabled = this.selected <= this.minimum;
        this.querySelector('[data-shift="1"]').disabled = this.selected >= this.maximum;
        this.querySelector('[data-today]').disabled = this.selected === todayKey();
      }
      renderDate(key) {
        const date = this.querySelector('[data-calendar-date]');
        date.dateTime = key;
        this.setText('[data-month]', this.dateFormat(key, { year: 'numeric', month: 'long' }));
        this.setText('[data-day]', this.dateFormat(key, { day: 'numeric' }));
        this.setText('[data-weekday]', this.dateFormat(key, { weekday: 'long' }));
        this.updateControls();
      }
      syncDisclosure() {
        this.querySelectorAll('[data-almanac-more]').forEach(button => button.setAttribute('aria-expanded', String(Boolean(this.details?.open))));
      }
      list(selector, ids, limit) {
        const element = this.querySelector(selector);
        if (!element) return;
        const names = [...new Set(ids)].map(id => this.activities[id]).filter(Boolean);
        const values = names.length ? names : [this.labels.none];
        const fragment = document.createDocumentFragment();
        values.slice(0, limit ?? values.length).forEach(name => { const li = document.createElement('li'); li.textContent = name; fragment.append(li); });
        if (limit && values.length > limit && this.details) {
          const li = document.createElement('li');
          li.className = 'cs-almanac__more';
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.almanacMore = '';
          button.setAttribute('aria-controls', this.details.id);
          button.setAttribute('aria-expanded', String(this.details.open));
          button.textContent = fill(this.labels.more, { count: values.length - limit });
          li.append(button);
          fragment.append(li);
        }
        element.replaceChildren(fragment);
      }
      clear() {
        ['[data-lunar]', '[data-year]', '[data-cycle]', '[data-term]', '[data-next-term]'].forEach(selector => this.setText(selector, '—'));
        this.setText('[data-chinese-date]', '');
        ['[data-yi]', '[data-ji]', '[data-yi-full]', '[data-ji-full]'].forEach(selector => this.querySelector(selector)?.replaceChildren());
      }
      async yearData(year) {
        const url = this.config.years[year];
        if (!url) throw new RangeError('Unavailable year');
        if (!cache.has(url)) {
          cache.set(url, (async () => {
            const abort = new AbortController();
            const timeout = window.setTimeout(() => abort.abort(), 10000);
            try {
              const response = await fetch(url, { signal: abort.signal, credentials: 'omit' });
              if (!response.ok) throw new Error('Calendar request failed');
              const data = await response.json();
              if (data.schema !== 1 || data.year !== Number(year) || data.timeZone !== 'Asia/Shanghai') throw new Error('Calendar data mismatch');
              return data;
            } finally { window.clearTimeout(timeout); }
          })().catch(error => { cache.delete(url); throw error; }));
        }
        return cache.get(url);
      }
      async load(key, animate = false) {
        if (key < this.minimum || key > this.maximum) {
          this.setText('[data-status]', this.labels.unavailable);
          this.body.setAttribute('aria-busy', 'false');
          return;
        }
        const token = ++this.token;
        this.selected = key;
        this.renderDate(key);
        this.clear();
        this.body.dataset.ready = 'false';
        this.body.setAttribute('aria-busy', 'true');
        this.setText('[data-status]', this.labels.loading);
        this.querySelector('[data-retry]').hidden = true;
        try {
          const data = await this.yearData(key.slice(0, 4));
          if (token !== this.token || !this.isConnected) return;
          const day = data.days[key];
          if (!day) throw new Error('Date unavailable');
          const commit = () => {
            if (token !== this.token) return;
            this.setText('[data-chinese-date]', day.chinese);
            const lunarFormat = day.lunar[1] < 0 ? this.labels.leapLunar : this.labels.lunar;
            this.setText('[data-lunar]', fill(lunarFormat, { month: Math.abs(day.lunar[1]), day: day.lunar[2] }));
            this.setText('[data-year]', fill(this.labels.year, { animal: this.animals[day.yearCycle % 12] }));
            this.setText('[data-cycle]', this.cycle(day.dayCycle));
            this.setText('[data-term-label]', day.todayTerm >= 0 ? this.labels.termToday : this.labels.term);
            this.setText('[data-term]', this.terms[day.todayTerm >= 0 ? day.todayTerm : day.currentTerm[0]]);
            this.setText('[data-next-term]', `${this.terms[day.nextTerm[0]]} · ${this.dateFormat(day.nextTerm[1], { month: 'short', day: 'numeric' })}`);
            this.list('[data-yi]', day.yi, 3);
            this.list('[data-ji]', day.ji, 3);
            this.list('[data-yi-full]', day.yi);
            this.list('[data-ji-full]', day.ji);
            this.setText('[data-status]', '');
            this.body.dataset.ready = 'true';
            this.body.setAttribute('aria-busy', 'false');
          };
          this.transition?.skipTransition();
          if (animate && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.transition = document.startViewTransition(commit);
            this.transition.finished.catch(() => {});
          } else commit();
        } catch (error) {
          if (token !== this.token || !this.isConnected) return;
          this.clear();
          this.setText('[data-status]', this.labels.error);
          this.querySelector('[data-retry]').hidden = false;
          this.body.setAttribute('aria-busy', 'false');
        }
      }
    }
    customElements.define('chinese-almanac', ChineseAlmanac);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('cs-footer-nav')) {
    customElements.define('cs-footer-nav', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.disclosures = Array.from(this.querySelectorAll('.cs-footer__disclosure'));
        this.update = () => {
          this.disclosures.forEach(details => {
            details.open = !this.media.matches;
            details.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
          });
        };
        this.onClick = event => {
          if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.addEventListener('click', this.onClick);
        this.media.addEventListener('change', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.media.removeEventListener('change', this.update);
      }
    });
  }

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
